<div class="side-container">
    <app-image-box [url]="logoPath$$()" [border]="false" />
</div>

@switch (viewState$$()) {
    @case ('request') {
        <form id="form" [formGroup]="RequestForm" autocomplete="chrome-off" (keyup.enter)="emit_requestReset()">
            <h2>Wachtwoord vergeten.</h2>
            <app-input-control [htmlAutocomplete]="'email'"
                [autofocus]="true"
                [control]="RequestFormControls.email"
                [label]="'email'"
                [lockOnLoad]="true"
                [placeholder]="'vul je e-mailadres in'"
                [showError]="showErrors || RequestForm.touched"
                [tabIndex]="'0'"
                [type]="'email'" />
            <div>
                <p class="my-1">
                    <a routerLink="/login">Terug naar login</a>
                </p>
            </div>
        </form>
    }
    @case ('requestSent') {
        <div class="message">
            <h2>Controleer je e-mail</h2>
            <p>Als dit e-mailadres bekend is, ontvang je een mail met een link om je wachtwoord opnieuw in te stellen.</p>
        </div>
    }
    @case ('requestFailed') {
        <div class="message">
            <h2>Er ging iets mis</h2>
            <p>De aanvraag kon niet worden verstuurd. Probeer het straks opnieuw.</p>
        </div>
    }
    @case ('reset') {
        <form id="form" [formGroup]="ResetForm" autocomplete="chrome-off" (keyup.enter)="emit_resetPassword()">
            <h2>Nieuw wachtwoord instellen.</h2>
            <app-input-control [htmlAutocomplete]="'new-password'"
                [autofocus]="true"
                [control]="ResetFormControls.password"
                [label]="'nieuw wachtwoord'"
                [lockOnLoad]="true"
                [placeholder]="'minimaal 10 tekens, met een cijfer'"
                [showError]="showErrors || ResetForm.touched"
                [tabIndex]="'0'"
                [type]="'password'" />
            <app-input-control [htmlAutocomplete]="'new-password'"
                [control]="ResetFormControls.passwordRepeat"
                [label]="'nieuw wachtwoord (herhaal)'"
                [lockOnLoad]="true"
                [placeholder]="'herhaal je nieuwe wachtwoord'"
                [showError]="showErrors || ResetForm.touched"
                [tabIndex]="'0'"
                [type]="'password'" />
            @if ((showErrors || ResetForm.touched) && ResetFormControls.password.errors?.['minlength']) {
                <p class="form-error">Wachtwoord moet minimaal 10 tekens bevatten.</p>
            }
            @if ((showErrors || ResetForm.touched) && ResetFormControls.password.errors?.['pattern']) {
                <p class="form-error">Wachtwoord moet minimaal 1 cijfer bevatten.</p>
            }
            @if ((showErrors || ResetForm.touched) && ResetForm.errors?.['passwordMismatch']) {
                <p class="form-error">De wachtwoorden komen niet overeen.</p>
            }
        </form>
    }
    @case ('resetDone') {
        <div class="message">
            <h2>Wachtwoord gewijzigd</h2>
            <p>Je kunt nu inloggen met je nieuwe wachtwoord.</p>
        </div>
    }
    @case ('resetFailed') {
        <div class="message">
            <h2>Link ongeldig of verlopen</h2>
            <p>Deze resetlink is niet meer geldig. Vraag een nieuwe aan.</p>
        </div>
    }
}

<ng-template #template_sectionDetails_extraButtons>
    @switch (viewState$$()) {
        @case ('request') {
            <app-button-action form="form"
                (btnClick)="emit_requestReset()"
                [loadKey]="loadKey"
                [lockOnLoad]="true"
            >verstuur resetlink</app-button-action>
        }
        @case ('reset') {
            <app-button-action form="form"
                (btnClick)="emit_resetPassword()"
                [loadKey]="loadKey"
                [lockOnLoad]="true"
            >wachtwoord instellen</app-button-action>
        }
        @case ('requestFailed') {
            <app-button-action (btnClick)="emit_requestAgain()">opnieuw proberen</app-button-action>
        }
        @case ('resetFailed') {
            <app-button-action (btnClick)="emit_requestAgain()">nieuwe link aanvragen</app-button-action>
        }
        @default {
            <app-button-action (btnClick)="emit_gotoLogin()">naar login</app-button-action>
        }
    }
</ng-template>
